import Vue from 'vue';
import VueRouter from 'vue-router';
import { Switch } from 'vant';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  //福利卡
  {
    path: '/',
    name: 'CardViews',
    component: () => import('../views/cardViews/CardViews.vue'),
    meta: {
      title: '福利卡',
      index: '/CardViews',
    },
  },
  //福利卡
  {
    path: '/AllCardViews',
    name: 'AllCardViews',
    component: () => import('../views/cardViews/AllCardViews'),
    meta: {
      title: '福利卡',
      index: '/AllCardViews',
    },
  },
  //福利卡
  {
    path: '/UserDetail',
    name: 'UserDetail',
    component: () => import('../views/cardViews/UserDetail'),
    meta: {
      title: '福利卡详情',
      index: '/UserDetail',
    },
  },
  {
    path: '/HomeNew',
    name: 'HomeNew',
    component: Home,
    meta: {
      title: '首页',
      index: '/',
      keepAlive: true
    },
  },

  {
    path: '/SearchGoods',
    name: 'SearchGoods',
    component: () => import('../views/SearchGoods'),
    meta: {
      title: '商品搜索',
      index: '/',
      keepAlive: true
    },
  },
  {
    path: '/UnifiedCashier',
    name: 'UnifiedCashier',
    component: () => import('../views/UnifiedCashier'),
    meta: {
      title: '收银台',
      keepAlive: false,
    },
  },
  // 订单等待页面
  {
    path: '/submitOrderWaiting',
    name: 'submitOrderWaiting',
    component: () => import('../views/submitOrderWaiting'),
    meta: {
      title: '订单处理中',
      keepAlive: false,
    },
  },
  // 订单已超时页面
  {
    path: '/orderTimeOut',
    name: 'orderTimeOut',
    component: () => import('../views/orderTimeOut'),
    meta: {
      title: '订单已超时',
      keepAlive: false,
    },
  },
  // 订单已取消页面
  {
    path: '/orderCancel',
    name: 'orderCancel',
    component: () => import('../views/orderCancel'),
    meta: {
      title: '订单已取消',
      keepAlive: false,
    },
  },
  // 登陆 注册
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/login/Login'),
    meta: {
      title: '登陆',
      index: '/Login',
      keepAlive: true,
    },
  },
  //协议
  {
    path: '/Agreement',
    name: 'Agreement',
    component: () => import('../views/login/Agreement'),
    meta: {
      title: '协议',
      index: '/Agreement',
    },
  },
  // 切换地址

  {
    path: '/SelectAdderss',
    name: 'SelectAdderss',
    component: () => import('../views/swithAdderss/SelectAdderss.vue'),
    meta: {
      title: '城市列表',
      index: '/SelectAdderss',
    },
  },
  // details 详情
  {
    path: '/Details',
    name: 'Details',
    component: () => import('../views/details/Details'),
    meta: {
      title: '详情',
      index: '/Details',
    },
  },
  {
    path: '/DetailsRecharge',
    name: 'DetailsRecharge',
    component: () => import('../views/details/DetailsRecharge'),
    meta: {
      title: '直充商品详情',
      index: '/DetailsRecharge',
    },
  },
  {
    path: '/DetailsDsCardCoupons',
    name: 'DetailsDsCardCoupons',
    component: () => import('../views/details/DetailsDsCardCoupons.vue'),
    meta: {
      title: '卡券商品详情',
      index: '/DetailsDsCardCoupons',
    },
  },
  {
    path: '/DetailsRyCard',
    name: 'DetailsRyCard',
    component: () => import('../views/details/DetailsRyCard.vue'),
    meta: {
      title: '仁跃卡券详情',
      index: '/DetailsRyCard',
    },
  },
  {
    path: '/DetailsDsV2/:thirdProductId',
    name: 'DetailsDsV2',
    component: () => import('../views/details/DetailsDsV2.vue'),
    meta: {
      title: '商品详情',
      index: '/DetailsDsV2',
    },
  },
  //购物车
  {
    path: '/CarViews',
    name: 'CarViews',
    component: () => import('../views/carViews/CarViews'),
    meta: {
      title: '购物车',
      index: '/CarViews',
    },
  },
  // 我的购物车
  {
    path: '/myCart',
    name: 'myCart',
    component: () => import('../views/myCart'),
    meta: {
      title: '购物车',
      index: '/myCart',
    },
  },
  // 结算页面
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: () => import('../views/confirmOrder'),
    meta: {
      title: '确认订单',
      index: '/confirmOrder',
    },
  },
  //福利卡升级
  {
    path: '/UpdateCard',
    name: 'UpdateCard',
    component: () => import('../views/cardViews/UpdateCard'),
    meta: {
      title: '福利卡升级',
      index: '/UpdateCard',
    },
  },

  {
    path: '/BindCard',
    name: 'BindCard',
    component: () => import('../views/cardViews/BindCard'),
    meta: {
      title: '绑定卡券',
      index: '/BindCard',
    },
  },

  {
    path: '/EnterpriseBuy',
    name: 'EnterpriseBuy',
    component: () => import('../views/cardViews/EnterpriseBuy'),
    meta: {
      title: '企业采购',
      index: '/EnterpriseBuy'
    }
  },


  // 我的
  {
    path: '/My',
    name: 'My',
    component: () => import('../views/my/My'),
    meta: {
      title: '我的',
      index: '/My',
    }
  },
  // 我的
  {
    path: '/AllMy',
    name: 'AllMy',
    component: () => import('../views/my/AllMy'),
    meta: {
      title: '我的',
      index: '/AllMy',
    }
  },
  // 电影-我的
  {
    path: '/MovieMy',
    name: 'MovieMy',
    component: () => import('../views/movie/MovieMy'),
    meta: {
      title: '我的',
      index: '/MovieMy',
    }
  },
  // 支付密码
  {
    path: '/SetPassWord',
    name: 'SetPassWord',
    component: () => import('../views/password/SetPassWord'),
    meta: {
      title: '验证身份',
      index: '/SetPassWord',
    }
  },
  // 分类
  {
    path: '/Classification',
    name: 'Classification',
    component: () => import('../views/classification/Classification'),
    meta: {
      title: '分类',
      index: '/Classification',
      keepAlive: true,
    }
  },
  // 个人资料
  {
    path: '/Personal',
    name: 'Personal',
    component: () => import('../views/my/Personal'),
    meta: {
      title: '个人资料',
      index: '/Personal'

    }
  },
  // 订单支付
  {
    path: '/ToOrder',
    name: 'ToOrder',
    component: () => import('../views/order/ToOrder'),
    meta: {
      title: '订单支付',
      index: '/ToOrder'

    }
  },
  // 订单详情
  {
    path: '/OrderDetail',
    name: 'OrderDetail',
    component: () => import('../views/order/OrderDetail'),
    meta: {
      title: '订单详情',
      index: '/OrderDetail'

    }
  },
  // 订单详情
  {
    path: '/CakaOrderDetail',
    name: 'CakaOrderDetail',
    component: () => import('../views/order/CakaOrderDetail'),
    meta: {
      title: '订单详情',
      index: '/CakaOrderDetail'

    }
  },
  // 浏览记录
  {
    path: '/History',
    name: 'History',
    component: () => import('../views/my/History'),
    meta: {
      title: '浏览记录',
      index: '/History'
    }
  },
  // 我的订单
  {
    path: '/AllOrder',
    name: 'AllOrder',
    component: () => import('../views/order/AllOrder'),
    meta: {
      title: '我的订单',
      index: '/AllOrder',
      keepAlive: true
    }
  },
  // 地址列表
  {
    path: '/AddressView',
    name: 'AddressView',
    component: () => import('../views/my/AddressView'),
    meta: {
      title: '地址列表',
      index: '/AddressView'
    }
  },
  // 地址编辑
  {
    path: '/EditAddress',
    name: 'EditAddress',
    component: () => import('../views/address/EditAddress'),
    meta: {
      title: '添加地址',
      index: '/EditAddress'
    }
  },

  // 电影首页
  {
    path: '/MoviesHome',
    name: 'MoviesHome',
    component: () => import('../views/movie/MoviesHome.vue'),
    meta: {
      title: '电影',
      index: '/MoviesHome',
      keepAlive: true
    }
  },
  // 聚合页：餐饮自提品牌列表
  {
    path: '/FoodBrandList',
    name: 'FoodBrandList',
    component: () => import('../views/categoryAggregate/FoodBrandList.vue'),
    meta: {
      title: '十节优选',
      index: '/FoodBrandList',
    }
  },
  // 聚合页：淘福客品牌列表
  {
    path: '/TaofukeBrandList',
    name: 'TaofukeBrandList',
    component: () => import('../views/categoryAggregate/TaofukeBrandList.vue'),
    meta: {
      title: '十节优选',
      index: '/TaofukeBrandList',
    }
  },
  // 电影看列表加搜索页
  {
    path: '/MoviesList',
    name: 'MoviesList',
    component: () => import('../views/movie/MoviesList'),
    meta: {
      title: '电影',
      index: '/MoviesList',
    }
  },
  // 影院列表搜索
  {
    path: '/CinemasList',
    name: 'CinemasList',
    component: () => import('../views/movie/CinemasList'),
    meta: {
      title: '影院',
      index: '/CinemasList',
      keepAlive: true

    }
  },
  // 影院
  {
    path: '/Cinema',
    name: 'Cinema',
    component: () => import('../views/movie/Cinema.vue'),
    meta: {
      title: '影院',
      index: '/Cinema',
    }
  },
  // 影院详情
  {
    path: '/CinemaDetail',
    name: 'CinemaDetail',
    component: () => import('../views/movie/CinemaDetail'),
    meta: {
      title: '影院详情',
    }
  },
  // 选票
  {
    path: '/Ticket',
    name: 'Ticket',
    component: () => import('../views/movie/Ticket'),
    meta: {
      title: '选票',
    }
  },
  // 电影详情
  {
    path: '/MovieDetail',
    name: 'MovieDetail',
    component: () => import('../views/movie/MovieDetail'),
    meta: {
      title: '电影详情',
    }
  },
  // 电影确认订单
  {
    path: '/ConfigOrder',
    name: 'ConfigOrder',
    component: () => import('../views/movie/ConfigOrder'),
    meta: {
      title: '确认订单',
    }
  },
  // 蛋糕首页
  {
    path: '/CakaHome',
    name: 'CakaHome',
    component: () => import('../views/cake/CakaHome.vue'),
    meta: {
      title: '蛋糕',
      index: '/CakaHome',
      keepAlive: true
    }
  },
  // 礼包商城首页
  {
    path: '/GiftPackageHome',
    name: 'GiftPackageHome',
    component: () => import('../views/giftPackageMall/giftPackageHome.vue'),
    meta: {
      title: '礼包商城',
      index: '/GiftPackageHome',
      keepAlive: true
    }
  },

  // 商品列表
  {
    path: '/GoodsList',
    name: 'GoodsList',
    component: () => import('../views/details/GoodsList.vue'),
    meta: {
      title: '商品列表',
      index: '/GoodsList',
      keepAlive: true
    },
  },
  // 预览模式入口
  {
    path: '/preview',
    name: 'PreviewAuth',
    component: () => import('../views/preview/index.vue'),
    meta: {
      title: '预览模式',
      noAuth: true
    }
  },
  // 活动/Banner 商品列表（统一页面）
  {
    path: '/ActivityGoodsList',
    name: 'ActivityGoodsList',
    component: () => import('../views/details/ActivityGoodsList'),
    meta: {
      title: '商品列表',
      index: '/ActivityGoodsList',
      keepAlive: true
    },
  },
  
  // 商品详情中点击品牌展示的商品列表
  {
    path: '/ProductList/:time/:brandName',
    name: 'ProductList',
    component: () => import('../views/details/ProductList'),
    meta: {
      title: '商品列表',
      index: '/ProductList',
      keepAlive: false,
    },
  },
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('../views/404'),
    meta: {
      title: '网址错误',
      index: '/404',
    },
  },
  // 签名
  // {
  //   path: '/sign',
  //   name: 'sign',
  //   component: () => import('../views/sign/sign'),
  //   meta: {
  //     title: '签名',
  //     index: '/sign',
  //     keepAlive: true,
  //     // refresh:true
  //   },
  // },
  // 获取用户信息
  // {
  //   path: '/getInfo',
  //   name: 'getInfo',
  //   component: () => import('../views/sign/getInfo'),
  //   meta: {
  //     title: '获取用户信息',
  //     index: '/getInfo',
  //     keepAlive: true,
  //     // refresh:true
  //   },
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
